import { combineReducers } from 'redux';
import allReducers from './reducers';

// keeping the reducer collection as a separate exported object enables us
// to do some light test automation on every reducer.
// see ./reducers/__tests__/reducerRejections.test.js
// for more details.
export const reducerCollection = {
  ...allReducers,
};

const reducers = combineReducers({ ...reducerCollection });

export default reducers;
